import React from "react";
import PropTypes from "prop-types";
import OrganizationForm from "./OrganizationForm";
import { useMutation } from "react-query";
import { createOrganization } from "../../../queries/organization";
import { createErrors } from "../../../queries/helpers";
import { useErrorHandler } from "react-error-boundary";
import { addAdminEmails, addCountry } from "../../helpers";

const NewOrganizationPage = ({ history, toast }) => {
  const handleError = useErrorHandler();
  const newOrganization = useMutation(async (formData) => {
    await createOrganization(formData);
  });

  const onSubmit = async (values) => {
    let new_values = { ...values };
    new_values = addCountry(new_values);
    new_values = addAdminEmails(new_values);
    return await newOrganization
      .mutateAsync(new_values)
      .then(() => {
        toast.success([
          {
            title: "Organization has been created",
            body: new_values.legalName,
          },
        ]);
        history.push("/");
      })
      .catch((error) => {
        toast.error([
          {
            title: "Failed to create organization",
            body: `${error.response.data.errors
              .map((error) => error.detail)
              .join(", ")}`,
          },
        ]);
        return createErrors(
          error,
          "Failed to create organization",
          handleError
        );
      });
  };

  return (
    <div className="container mw-520">
      <h3 className="mb-4">New Organization</h3>
      <OrganizationForm onSubmit={onSubmit} />
    </div>
  );
};

NewOrganizationPage.propTypes = {
  history: PropTypes.object.isRequired,
  toast: PropTypes.func.isRequired,
};

export default NewOrganizationPage;
